import $ from 'jquery';
import Swiper from 'swiper';
import HelperCtrl from '../inc/helper';

const Helper = new HelperCtrl();

function SwiperCtrl() {



	this.breadcrumb = this.breadcrumb.bind(this);
	this.init();
}

SwiperCtrl.prototype.init = function() {
	var breadcrumb = new Swiper('.bread-container', this.breadcrumb());
	var catalogCarousel = new Swiper('.catalog-swiper', this.catalogCarousel());
	var staffCarousel = new Swiper('.other-staff-list', this.staffCarousel());
}

SwiperCtrl.prototype.breadcrumb = function() {
	const $breadcrumb = $('.bread-container');
	const leng = $breadcrumb.find('li').length;
	return {
		scrollbar: {
			hide: true,
		},
		initialSlide: leng,
		freeMode: true,
		slidesPerView: 'auto',
		spaceBetween: 0,
	}
}

SwiperCtrl.prototype.catalogCarousel = function() {
	let center = false;
	let free = false;
	let wheel = false;

	if (Helper.isMobile()) {
		center = true;
		free = true;
		wheel = true;
	}

	return {
		navigation: {
			nextEl: '.catalog-list-next',
			prevEl: '.catalog-list-prev',
		},
		scrollbar: {
			el: '.catalog-scrollbar',
			hide: false,
		},
		freeMode: free,
		slidesPerView: 'auto',
		centeredSlides: center,
		spaceBetween: 8,
		grabCursor: true,
		speed: 800,
		// autoplay: 4000,
		autoplayDisableOnInteraction: false,
		// mousewheelControl: true
	}
}

SwiperCtrl.prototype.staffCarousel = function() {
	let center = false;
	if (Helper.isMobile()) {
		center = true;
	}
	return {
		// scrollbar: '.cat-tag-scrollbar',
		// scrollbarHide: false,
		// freeMode: true,
		pagination: {
			el: '.staff-list-pagination',
			clickable: true
		},
		navigation: {
			nextEl: '.staff-list-next',
			prevEl: '.staff-list-prev',
		},
		slidesPerView: 'auto',
		centeredSlides: center,
		spaceBetween: 32,
		grabCursor: true
	}
}

new SwiperCtrl();